module.exports = __webpack_public_path__ + "static/media/icons-info.66fa6c72.svg";